import * as React from 'react';
import { useInView } from 'react-intersection-observer';
import { defaultLoadingClass } from './Constants';
import './LazyImage.scss';

interface LazyImageProps {
  altText: string;
  src: string;
  containerRef?: React.RefObject<Element>;
  classes?: string;
  loadingClasses?: string;
  rootMargin?: string;
  height?: string;
  width?: string;
  fallbackURL?: string;
}

const LazyImage = (props: LazyImageProps) => {
  const {
    src,
    altText,
    classes,
    loadingClasses,
    rootMargin,
    containerRef,
    height,
    width,
    fallbackURL,
  } = props;
  const [ref, inView] = useInView({
    root: containerRef?.current || null,
    triggerOnce: true,
    rootMargin: rootMargin || '200px 200px 200px 200px',
  });

  const imageOnErrorHandler = (
    event: React.SyntheticEvent<HTMLImageElement, Event>,
  ) => {
    if (typeof fallbackURL === 'string') {
      // eslint-disable-next-line no-param-reassign
      event.currentTarget.src = fallbackURL;
    }
  };

  return (
    <span className="sui-inline-block" ref={ref}>
      {inView ? (
        <img
          className={classes}
          src={src}
          alt={altText}
          height={height}
          width={width}
          onError={imageOnErrorHandler}
        />
      ) : (
        <div className={loadingClasses || defaultLoadingClass} />
      )}
    </span>
  );
};

export { LazyImage };
